import React, {Component} from 'react';
import {NavLink} from 'react-router-dom';
import AppBreadcrumbs from './AppBreadcrumbs';

class FilterHasResults extends Component {
    render(){
        let favorites = []
        if(localStorage.getItem('favorites')){
            favorites = localStorage.getItem('favorites').split("&").slice(0, -1);
        }
        console.log(favorites);

        function addToFavorites(id){
            
            if(!favorites.includes(id)){
                favorites.push(id);

                let result = "";
                favorites.forEach(function(favorite){
                    result+=(favorite+'&');
                });
                localStorage.setItem('favorites', result);
                window.location.reload();
            }
    
        }

        const mcardResults = this.props.mcards.map(mcard => 
            <li>
                <h3>
                    {mcard.title}
                </h3>
                <p>
                    {mcard.description}
                </p>
                <div class="werkvormoptie">
                    <div className={favorites.includes(String(mcard.id)) ? 'hideme': 'left'}>
                        <a onClick={addToFavorites.bind(this, mcard.id)}>
                            <p>
                                Voeg toe
                            </p>
                            <div class="voegtoe"></div>
                        </a>
                    </div>
                    <div class="right">
                        <NavLink to={'/methodekaart/'+mcard.id}>
                            Bekijk werkvorm
                            <img src="img/pijl-rechts-zwart_2x.png" alt="Pijl-Rechts"/>
                        </NavLink>
                    </div>
                </div>
            </li>
        )
        return(
            <div>
                <section className="title">
                    <h2>
                        Er zijn {this.props.amount} werkvormen <br/> beschikbaar_
                    </h2>
                </section>

                {/* <section className="filtermenu">
                    <ul>
                        {filterOptionList}
                    </ul>
                </section> */}
                <AppBreadcrumbs />

                <section class="resultaten-favorieten">
                    <ul>
                        {mcardResults}
                        
                    </ul>
                </section>
            </div>
        )
    }
}

export default FilterHasResults;